import { useRequiredParams } from '@pba/react-router';
import { AppLayout } from 'layouts';
import { ProgramMembers } from 'features/programs';

const PageProgramMembers = () => {
  const { programId } = useRequiredParams<{ programId: string }>();

  return (
    <AppLayout>
      <ProgramMembers programId={programId} />
    </AppLayout>
  );
};

export default PageProgramMembers;
